<template>
  <v-container :fluid="true" class="bg-light-beige" style="height: 100vh; height: var(--doc-height); overflow-y: hidden !important;">
    <v-row align="center"
           justify="center"
           no-gutters
           style="height: 100%"
    >
      <div class="text-lg-left flex-wrap d-inline-flex" :style="$vuetify.display.mdAndUp ? 'width: 70vw' : 'width: 100vw'">
        <v-col cols="12" lg="7" class="pr-4" align-self="center">
          <span class="text-left">
            <h1 class="text-h4 text-sm-h2 py-1 py-md-2 font-weight-bold" style="color: #313743">Технические работы</h1>
            <h2 class="text-h5 text-sm-h4 py-2 py-md-1 medium-primary">
              <span class="typewriter" style="color: #3254B9"></span>
            </h2>
            <p class="text-sm-h6 text-body-1 text-grey-darken-2">Уважаемый пользователь,</p>
            <p class="text-sm-h6 text-body-1 text-grey-darken-2">По техническим причинам личный кабинет пользователя недоступен.</p>
            <p class="text-sm-h6 text-body-1 text-grey-darken-2">Пожалуйста, попробуйте авторизоваться позднее.</p>
            <p class="text-sm-h6 text-body-1 text-grey-darken-2">При необходимости, обратитесь в <a href="mailto:help@mendeleevskayakarta.ru" class="text-decoration-none" style="color: #376FFE">службу поддержки</a> проекта.</p>
          </span>
        </v-col>
        <v-col cols="12" lg="5" class="pl-4 mt-10 mt-md-0" align-self="center">
          <v-img
            :src="mendel"
            :max-height="$vuetify.display.lgAndUp ? 400 : 200"
          >
          </v-img>
        </v-col>
      </div>
    </v-row>
  </v-container>

</template>

<script>
import mendel from '@/assets/img/header_logo.png'

export default {
  name: 'PageNotLoad',
  data () {
    return {
      mendel: mendel,
    }
  },
  methods: {
    documentHeight () {
      const doc = document.documentElement
      doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
    }
  },
  mounted () {
    window.addEventListener("resize", this.documentHeight)
    this.documentHeight()
  },
  unmounted () {
    window.removeEventListener("resize", this.documentHeight)
  },
}
</script>

<style scoped>
/* Typewriter effect */
@keyframes typing {
  0%, 54% { content: ""; }
  1%, 53% { content: "У"; }
  1.5%, 52% { content: "Уп"; }
  2%, 51% { content: "Упс"; }
  3%, 50% { content: "Упс,"; }
  4%, 49% { content: "Упс, "; }
  5%, 48% { content: "Упс, ч"; }
  7%, 47% { content: "Упс, чт"; }
  8%, 46% { content: "Упс, что"; }
  9%, 45% { content: "Упс, что-"; }
  10%, 44% { content: "Упс, что-т"; }
  11%, 43% { content: "Упс, что-то"; }
  12%, 42% { content: "Упс, что-то "; }
  13%, 41% { content: "Упс, что-то п"; }
  14%, 40% { content: "Упс, что-то по"; }
  15%, 39% { content: "Упс, что-то пош"; }
  16%, 38% { content: "Упс, что-то пошл"; }
  17%, 37% { content: "Упс, что-то пошло"; }
  18%, 36% { content: "Упс, что-то пошло "; }
  19%, 35% { content: "Упс, что-то пошло н"; }
  20%, 34% { content: "Упс, что-то пошло не"; }
  21%, 33% { content: "Упс, что-то пошло не "; }
  22%, 32% { content: "Упс, что-то пошло не т"; }
  23%, 31% { content: "Упс, что-то пошло не та"; }
  24%, 30% { content: "Упс, что-то пошло не так"; }

  59%, 97% { content: ""; }
  60%, 96% { content: "С"; }
  61%, 95% { content: "Са"; }
  62%, 94% { content: "Сай"; }
  63%, 93% { content: "Сайт"; }
  64%, 92% { content: "Сайт "; }
  65%, 91% { content: "Сайт н"; }
  66%, 90% { content: "Сайт не"; }
  67%, 89% { content: "Сайт не "; }
  68%, 88% { content: "Сайт не д"; }
  69%, 87% { content: "Сайт не до"; }
  70%, 86% { content: "Сайт не дос"; }
  71%, 85% { content: "Сайт не дост"; }
  72%, 84% { content: "Сайт не досту"; }
  74%, 83% { content: "Сайт не доступ"; }
  76%, 82% { content: "Сайт не доступе"; }
  78%, 80% { content: "Сайт не доступен"; }
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

.typewriter {
  --caret: currentcolor;
}

.typewriter::before {
  content: "";
  animation: typing 13.5s infinite;
}

.typewriter::after {
  content: "";
  border-right: 1px solid var(--caret);
  animation: blink 0.5s linear infinite;
}

.typewriter.thick::after {
  border-right: 1ch solid var(--caret);
}

.typewriter.nocaret::after {
  border-right: 0;
}

@media (prefers-reduced-motion) {
  .typewriter::after {
    animation: none;
  }

  @keyframes sequencePopup {
    0%, 100% { content: "Упс, что-то пошло не так"; }
    55% { content: "Упс, что-то пошло не так"; }
    98% { content: "Страница не найдена"; }
  }

  .typewriter::before {
    content: "developer";
    animation: sequencePopup 12s linear infinite;
  }
}

:root {
  --doc-height: 100vh;
}
</style>
